import "./style.css";

import PhotoPuzzleDialog from './modules/PhotoPuzzleDialog.mjs';
import JSConfetti from './node_modules/js-confetti/dist/es/index.js';

document.addEventListener('DOMContentLoaded', evt => {
	let gallery = document.querySelector('.ux-gallery');

	gallery.addEventListener('click', (evt) => {
		if (evt.target.nodeName === 'IMG') {
			let img_url = '../assets/' + evt.target.dataset['image'];
			let dlg = PhotoPuzzleDialog(img_url);

			dlg.on('win', (data) => {
				const jsConfetti = new JSConfetti();

				jsConfetti.addConfetti({
				  emojis: ['❤️'],
				  emojiSize: 24,
				  confettiNumber: 45,
				})
			})

			dlg.open();
		}
	})
})
